/*eslint-disable */

function Enum(a) {
    let i = Object.keys(a).reduce((o, k) => (o[a[k]] = k, o), {});
    return Object.freeze(
        Object.keys(a).reduce((o, k) => (o[k] = a[k], o), v => i[v])
    );
}

export const PlatformMode = Enum({
    Home: 'home',
    Create: 'create',
    Edit: 'edit',
    View: 'view',
});

export const StudioDrawerState = Enum({
    None: 'none',
    Info: 'info',
    Library: 'library',
    Learn: 'learn',
    Preview: 'preview'
});

export const StudioLibraryState = Enum({
    Sample: 'sample',
    Uploads: 'uploads'
});

export const StudentStatus = Enum({
    Invited: 0,
    Activated: 1,
    Demo: 2,
    Trial: 3,
    Inactive: 4,
    NotInvited: 5,
    Fake: 6,
    TrialEnded: 7
});

export const UserStatus = Enum({
    Pending: 'pending',
    Trial: 'trial',
    Active: 'active',
    Inactive: 'inactive',
    TrialEnded: 'trial-ended'
});

export const PaymentStatus = Enum({
    Active: 'Active',
    Suspended: 'Suspended',
    Terminated: 'Terminated',
    Finished: 'Finished'
});

export const PaymentType = Enum({
    Monthly: 'monthly',
    Yearly: 'yearly'
});

export const PaymentSteps = Enum({
    Plan: 'plan',
    Seats: 'seats',
    Purchase: 'purchase'
});

export const PaymentErrors = Enum({
    SomethingWrong: 'somethingWrong',
    YearlyPlan: 'yearlyPlan',
});

export const TrackPlayStatus = Enum({
    Stopped: 0,
    Paused: 1,
    Playing: 2
});

export const DialogType = Enum({
    Alert: 0,
    Confirm: 1
});

export const LessonState = Enum({
    Create: 'create_lesson',
    Publish: 'publish_lesson',
    Update: 'update_lesson',
});

export const VideoRecorderState = Enum({
    Preview: 'preview',
    Recording: 'recording',
    Save: 'save',
});

export const NotificationType = Enum({
    Project: 'project',
    TrackLooped: 'trackLooped',
    RenameProject: 'renameProject',
    ShareProject: 'shareProject',
    Lesson: 'Lesson',
    User: 'user',
    Video: 'video',
    Canvas: 'canvas',
    Module: 'module'
});

export const NotificationCategoryType = Enum({
    Messenger: 'messenger',
    System: 'system'
});


export const ProjectNotificationType = Enum({
    ChatMessage: 'chatMessage',
    ProjectRequestApproved: 'projectRequestApproved',
    Rename: 'renameProject',
    Share: 'shareProject',
    Save: 'saveProject',
    Leave: 'leaveProject',
    MusicMessage: 'musicMessage'
});

export const LessonNotificationType = Enum({
    OpenLessonFirst: 'openLessonFirst',
    OpenLesson: 'openLesson',
    EditLesson: 'editLesson',
    PerformanceAddedToLesson: 'performanceAddedToLesson',
    VideoAddedToLesson: 'videoAddedToLesson',
    AudioAddedToLesson: 'audioAddedToLesson',
    WhiteboardAddedToLesson: 'whiteboardAddedToLesson',
    Reminder: 'reminder',
    Delete: 'delete',
    Chat: 'chat',
    CanvasUpdate: 'canvasUpdate',
    LessonUpdate: 'lessonUpdate',
    Presenting: 'presenting',
    LessonUpdateRequest: 'lessonUpdateRequest',
    Navigation: 'navigation',
    Assigned: 'assigned',
    LessonActionUpdate: 'lessonActionUpdate',
});

export const UserNotificationType = Enum({
    StudentSignedUp: 'studentSignedUp',
    StudentListUpdated: 'studentListUpdated',
});

export const VideoNotificationType = Enum({
    MissedCall: 'missedCall',
    EnterRoom: 'enterRoom'
});

export const ModuleNotificationType = Enum({
    NewModule: 'newModule',
    EditModule: 'editModule',
    DeleteModule: 'deleteModule',
    MoveModule: 'moveModule'
});



export const ProjectStatus = Enum({
    PrivateOwner: 0,
    Private: 1,
    Public: 2
});

export const ProjectType = Enum({
    Project: '0',
    Lesson: '1',
    Global: '2',
});

export const TrackActionType = Enum({
    Mute: 0,
    StartOffset: 1,
    Paste: 2,
    UnMute: 3,
    Cut: 4,
    Highlight: 5,
    Copy: 6,
    Padding: 7,
    LeftTrimOffset: 8,
    RightTrimOffset: 9,
    Split: 10,
    SplitRemove: 11,
    ChangeTSCount: 12,
    ChangeTSMeter: 13
});

export const ChatType = Enum({
    Project: 'project',
    User: 'user'
});

export const TrackType = Enum({
    Track: 'track',
    Project: 'project',
    shared: 'shared'
});


export const ProgressPresentationType = Enum({
    Bars: 0,
    Time: 1
});

export const UploadType = Enum({
    Record: 'record',
    UploadFile: 'uploadFile',
    EditFile: 'EditFile',
});

export const RecorderState = Enum({
    Init: 'init',
    Record: 'record',
    Stop: 'pause',
    Countdown: 'countdown',
    Done: 'done'
});

export const RecorderDialogState = Enum({
    Record: 'recorded',
    Upload: 'upload',
    Panel: 'panel',
    Error: 'error',
    LatencyTest: 'latencyTest'
});

export const AlertType = Enum({
    Success: 'success',
    Info: 'info',
    Warning: 'warn',
    Error: 'error',
    Default: 'default'
});

export const PlayButtonMode = Enum({
    PlayPause: 'playPause',
    MuteUnmute: 'muteUnmute'
});

export const PowerState = Enum({
    Off: 0,
    On: 1
});
export const Roles = Enum({
    Student: 0,
    Teacher: 1,
    Admin: 2,
    SchoolAdmin: 3
});

export const MediaRecorderType =  Enum({
    Internal: 'internal',
    Streaming: 'streaming'
});

export const VolumeStage = Enum({
    click: 0,
    mute: 1,
    unmute: 2
});

export const SearchState = Enum({
    sampleBank: 0,
    myUploads: 1,
    studentLessons: 2,
    teacherLessons: 3,
    studentsProjects: 4,
    studentActivities: 5,
    lessonActivities: 6,
    studentsDrafts: 7,
    discovery: 8,
    lessonPlanLibrary: 9,
    discoveryPublic: 10,
    introLessons: 11,
    lessonsLibrary: 12
});

export const InstrumentCategories = Enum({
    Guitar: 'Guitar',
    WoodwindsAndBrass: 'Woodwinds and Brass',
    Bass: 'Bass',
    Strings: 'Strings',
    Vocals: 'Vocals',
    Drums: 'Drums',
    PianoAndKeys: 'Piano',
    Synthesizer: 'Synthesizer',
    Percussion: 'Percussion',
    ElectronicBeat: 'Electronic Beat',
    Brass: 'Brass',
    Keyboard: 'Keyboard',
    BowStrings: 'Bow Strings',
    Woodwinds: 'Woodwinds',
    Synth: 'Synth',
    Other: 'Other'
});

export const actions = Enum({
    Click: 'Click',
    ClickNew: 'ClickNew',
    PlayLoopers: 'Play Loopers',
    Monitor: 'Monitor',
    Close: 'Close',
    ClickTask: 'Click Task',
    ClickVideo: 'Click Video',
    ClickNotation: 'Click Notation',
    ClickAudio: 'Click Audio',
    RemoveVideo: 'Remove Video',
    AddVideo: 'Add Video',
    ClickAddVideo: 'Click Add Video',
    LoginSuccess: 'Login Success',
    SignOut: 'Sign Out',
    MobileLink: 'Mobile Link',
    CompleteRegistration: 'Complete Registration',
    OnBoardingDone: 'OnBoardingDone',
    RequestDemo: 'Request a Demo',
    AddStem: 'Add Stem',
    AddProject: 'Add Project',
    Play: 'Play',
    Pause: 'Pause',
    Clear: 'Clear',
    Remove: 'Remove',
    ClickUnmute: 'ClickUnmute',
    ClickMute: 'ClickMute',
    ToggleAdvancedMode: 'ToggleAdvancedMode',
    ToggleWaveform: 'ToggleWaveform',
    ToggleShowLooper: 'ToggleShowLooper',
    ClickSolo: 'Click Solo',
    SaveProject: 'Save Project',
    OpenDrawer: 'Open Drawer',
    CloseDrawer: 'Close Drawer',
    ClickThumbnail: 'ClickThumbnail',
    OpenAddBar: 'OpenAddBar',
    ClickAddButton: 'ClickAddButton',
    OpenSettings: 'OpenSettings',
    EditSkills: 'EditSkills',
    EditVideo: 'EditVideo',
    RemoveFile: 'RemoveFile',
    DownloadFile: 'DownloadFile',
    RenameFile: 'RenameFile',
    ClickRecord: 'ClickRecord',
    ClickAttachLink: 'ClickAttachLink',
    OpenSampleBank: 'OpenSampleBank',
    OpenLibrary: 'OpenLibrary',
    DropFile: 'DropFile',
    UploadFile: 'UploadFile',
    TakeAPicture: 'TakeAPicture',
    ClickEditText: 'ClickEditText',
    ClickEditAndAssign: 'ClickEditAndAssign',
    Quit: 'Quit',
    Open: 'Open',
    OpenLesson: 'Open Lesson',
    PlayOrPause: 'Play | Pause',
    Cut: 'Cut',
    Copy: 'Copy',
    Paste: 'Paste',
    Delete: 'Delete',
    Slice: 'Slice',
    MusicMessage: 'Music Message',
    NewStem: 'New Stem',
    ColorChange: 'Color Change',
    Undo: 'Undo',
    Redo: 'Redo',
    MoveBarForward: 'Move Bar Forward',
    MoveBarBackward: 'Move Bar Backward',
    OpenMessenger: 'OpenMessenger',
    MetronomeOn: 'Metronome On',
    MetronomeOff: 'Metronome Off',
    PitchChange: 'PitchChange',
    SeekTo: 'Seek To',
    ChangeBPM: 'Change BPM',
    ChangeBeatCount: 'Change Beat Count',
    Select: 'Select',
    ClearSelection: 'Clear Selection',
    Trim: 'Trim',
    Drag: 'Drag',
    Time: 'Time',
    EditTrack: 'Edit Track',
    AddName: 'Add Name',
    AddGenre: 'Add Genre',
    RemoveGenre: 'Remove Genre',
    RemoveInstrument: 'Remove Genre',
    AddFile: 'Add File',
    AddAttachment: 'Add File Attachment',
    AddFileError: 'Add File Error',
    ToggleBpmCalculator: 'Toggle Bpm Calculator',
    Recorder: 'Recorder',
    OpenStudio : 'Open Studio',
    OpenAccessDialog: 'OpenAccessDialog',
    CloseAccessDialog: 'CloseAccessDialog',
    ClickSelectAStudent: 'Click Select A Student',
    ClickAddStudent: 'Click Add Student',
    ClickDemoStudent: 'Click Demo Student',
    ClickStudent: 'ClickStudent',
    ClickAddGroup: 'Click Add Group',
    AddGroup: 'Add Group',
    CloseGroupDialog: 'Close Group Dialog',
    RemoveStudent: 'Remove Student',
    StudentAdded: 'Student Added',
    StudentAddedNoEmail: 'Student Added No Email',
    ChangeTab : 'Change Tab',
    CreateNewLesson: 'Create New Lesson',
    CreateNewLessonFromLibrary: 'Create New Lesson From Library',
    CreateNewLessonFromDiscover: 'Create New Lesson From Discover',
    ClickCreateNewLesson: 'Click Create New Lesson',
    ClickCreateNewLessonFromLibrary: 'Click Create New Lesson From Library',
    ClickCreateNewLessonFromSharedLibrary: 'Click Create New Lesson From Shared Library',
    ClickCreateNewLessonFromDiscover: 'Click Create New Lesson From Discover',
    ClickCreateNewTopicAndNotes: 'Click Create New Topic And Notes',
    ClickCreateModule: 'Click Create Module',
    CreateNewLessonFromWhiteboard: 'Click Create New Lesson From Whiteboard',
    CreateNewLessonFromPractice: 'Create New Lesson From Practice',
    CreateFromPlanOpen: 'Create From Plan and Open',
    CreateFromPlanLater: 'Create From Plan for Later',
    ClickNewLesson: 'Click New Lesson',
    ClickLessonPlan: 'Click Lesson Plan',
    OpenLessonInfo: 'Open Lesson Info',
    OpenAssignStudents: 'Open Assign Students',
    OpenLessonPlanDialog: 'Open Lesson Plan Dialog',
    ShareLessonToSchoolLibrary:'Share Lesson To School Library',
    CopyMagicLink: 'Copy Magic Link',
    SendInvite: 'Send Invite',
    ResendInvite: 'Resend Invite',
    LessonReminder: 'Lesson Reminder',
    ClickShareStudent: 'Share Student Link',
    Assign: 'Assign',
    AssignSave: 'Assign Save',
    MakePublic: 'MakePublic',
    MakeNotPublic: 'MakeNotPublic',
    OpenTutorial: 'OpenTutorial',
    Error: 'Error',
    OpenDialog: 'OpenDialog',
    ClickBookNow: 'Click Book Now',
    School:'School',
    LatencyTest: 'Latency Test',
    MeetingBooked: 'Meeting Booked',
    MeetingBookingCanceled: 'Meeting Booking Canceled',
    ClickSelectAll: 'ClickSelectAll',
    ClickGroup: 'ClickGroup',
    SubmitPricingBanner: 'SubmitPricingBanner',
    AccountSettings: 'AccountSettings',
    StartAMeeting: 'Start a meeting',
    InsertLink: 'Insert Link',
    PurchaseConfirmed: 'Purchase Confirmed',
    Purchase: 'Purchase',
    AddToCart: 'Add To Cart',
    ClickRealTime: 'Click Real Time',
    OpenStudentVideo: 'Open Student Video',
    CloseStudentVideo: 'Close Student Video',
    OpenTutorialVideo: 'Open Tutorial Video',
    CloseTutorialVideo: 'Close Tutorial Video',
    ShowGuide: 'Show Guide',
    DoneGuide: 'Done Guide',
    SkipGuide: 'Skip Guide',
    NextGuide: 'Next Guide',
    BackGuide: 'Back Guide',
    NotFoundStepGuide: 'Not Found Step Guide',
    Share: 'Share',
    ToggleVideoLesson: 'Toggle Video Lesson',
    Shortcuts: 'Shortcuts',
    AddFolder: 'Add Folder',
    NewSharedFolder: 'New Shared Folder',
    DropAction: 'Drop Action',
    DragAction: 'Drag Action',
    OnTopicBlur: "On Topic Blur",
    OnNoteSave: "On Note Save",
    OnClickViewNote: "On Click Viewed Note",
    AddInstructions: 'Add Instructions',
    PlayVideo: 'Play Video',
    SelectFilters: 'select Multiple Filters',
    OpenCollection: 'Open Collection',
    FilterTimeline: 'Filter Timeline',
    FromTimeline: 'From Timeline',
    FromNotation: 'From Notation',
    FromWhiteboard: 'From Whiteboard',
    FromHomepage: 'From Homepage',
    StudentAssignment: 'Student Assignment',
    PublicLink: 'Public Link',
    FromLibrary: 'From Library',
    FromSharedLibrary: 'From Shared Library',
    FromScratch: 'From Scratch',
    FromMusicoLibrary: 'From Musico Library',
    New: 'New',
    Assignment: 'Assignment',
    Lesson: 'Lesson',
    FromStudio: 'From Studio',
    Upload: 'Upload',
    MusicoSamples: 'Musico Samples',
    Library: 'Library',
    Link: 'Link',
    FromSignIn: 'From SignIn',
    FromSchoolLibrary: 'From School Library',
    NewAssignment: 'New Assignment'
});

export const category = Enum({
    Login: 'Login',
    SignUp: 'SignUp',
    LooperSection: 'Looper Section',
    Explore: 'Explore',
    Studio: 'Studio',
    Upload: 'Upload',
    Record: 'Record',
    Lesson: 'Lesson',
    Group: 'Group',
    Home: 'Home',
    StudentAssignments: 'Student Assignments',
    SelectAStudent: 'Select A Student',
    LessonPlan: 'LessonPlan',
    Overview: 'Overview',
    Practice: 'Practice',
    ManageStudents: 'Manage Students',
    Support: 'Support',
    FAQ: 'FAQ',
    Promo: 'Promo',
    Meeting: 'Meeting',
    OnBoarding: 'OnBoarding',
    Notations: 'Notations',
    Discover: 'Discover',
    Pricing: 'Pricing',
    Zoom: 'Zoom',
    Video: 'Video',
    Referral: 'Referral',
    Folders: 'Folders',
    LessonLibrary: 'Lesson Library',
    SchoolAdmin: 'School Admin',
    Timeline: 'Timeline',
    Notes: "Notes",
    TimelineSearch : "Timeline search",
    ChiliPiper : 'Chili Piper',
    FilterLesson: "Filter Lesson",
    HomePageFlow: "HomepageFlow",
    FullScreen: 'FullScreen',
    SaveLesson: 'Save Lesson',
    AddMarkup: 'Add Markup',
    LaunchVideoLesson: 'Launch Video Lesson',
    ShareLink: 'Share Link',
    AssignLesson: 'Assign Lesson',
    AssignGroupLesson: 'Assign Group Lesson',
    ViewCollection: 'View Collection',
    SaveMusicoLesson: 'Save Musico Lesson',
    AddStudent: 'Add Student',
    CreateProject: 'Create Project',
    AddGroup: 'Add Group',
    StudentConnected: 'Student Connected',
    SaveChanges: 'Save Changes',
    AddNotation: 'Add Notation',
    AddInstructions: 'Add Instructions',
    RecordAudio: 'Record Audio',
    RecordVideo: 'Record Video',
    AddAudio: 'Add Audio',
    AddVideo: 'Add Video',
    PlayVideo: 'Play Video',
    PlayAudio: 'Play Audio',
    UploadWhiteboard: 'Upload Whiteboard',
    AddWhiteboard: 'Add Whiteboard',
    AddPhoto: 'Add Photo',
    ChangeBPM: 'Change BPM',
    MetronomeOn: 'Metronome On',
    AddAssignmentToTimeline: 'Add Assignment to Timeline',
    LaunchRealTime: 'Launch Real Time',
    FilterTimeline: 'Filter Timeline',
    ViewNotes: 'View Notes',
    AddTopic: 'Add Topic',
    AddNotes: 'Add Notes',
    SendMessage: 'Send Message',
    ViewMusicoLesson: 'View Musico Lesson',
    AddToTimeline: 'Add to Timeline',
    CreateLibraryLesson: 'Create Library Lesson',
    StudentRemoved: 'Student Removed',
    AddFolder: 'Add Folder',
    ShareLessonToSchoolLibrary:'Share Lesson To School Library',
    Unsubscribe: 'Unsubscribe',
    ChangePlan: 'Change Plan',
    Subscribe: 'Subscribe',
    AddToHomeScreenSuggested: 'Add to Homescreen Suggested',
    AddedToHomeScreen: 'Added to Homescreen',
    AddToHomeScreenDismissed: 'Add to Homescreen Dismissed',
    ChangeTheme: 'Change Theme',
    ChangeAvatar: 'Change Avatar'
});

export const loaderColor = Enum({
    grayLoader: 'grayLoader',
    secondaryLoader: 'secondaryLoader',
    whiteLoader: 'whiteLoader',
});

export const events = Enum({
    // pageview
    CustomEvent: 'CustomEvent',
    ActivateStudent:"Student Activated",
    Identify: 'Identify',
    Experiment: 'Experiment',
    SetUserInfo: 'SetUserInfo',
    UpdateStudentActivity: 'UpdateStudentActivity',
    UpdatePaymentStatus: 'UpdatePaymentStatus',
    ClearIdentity: 'ClearIdentity',
    PageView: 'PaveView',
    StudioPageView: 'StudioPageView',
    LessonsPageView: 'LessonsPageView',
    LoginPageView: 'LoginPageView',
    SignUpPageView: 'SignUpPageView',
    SignUpSelectPageView: 'SignUpSelectPageView',
    SignUpChangePasswordPageView: 'SignUpChangePasswordPageView',
    LandingPageView: 'LandingPageView',
    FeedPageView: 'FeedPageView',
    HomePageView: 'HomePageView',
    LessonPlansPageView: 'LessonPlansPageView',
    DiscoverPageView: 'DiscoverPageView',
    OverviewPageView: 'OverviewPageView',
    DraftsPageView: 'DraftsPageView',
    ProjectsPageView: 'ProjectsPageView',
    SignUpConfirmationPageView: 'SignUpConfirmationPageView',
    SessionPageView: 'SessionPageView',
    LandingPageStudioPageView: 'landingPageStudioPageView',
    LandingPageFeedPageView: 'landingPageFeedPageView',
    LandingPageAuthPageView: 'landingPageAuthPageView',
    CreatePageView: 'CreatePageView',
    PracticeLibraryPageView: 'PracticeLibraryPageView',
    LibraryPageView: 'LibraryPageView',
    AccountSettingsPageView: 'AccountSettingsPageView',
    StudentListPageView: 'StudentListPageView',
    PricingPageView: 'PricingPageView',
    SupportPageView: 'SupportPageView',
    MeetingsPageView: 'MeetingsPageView',
    TimeLinePageView: 'TimeLine PageView',
    GroupTimelinePageView: 'Group Timeline PageView',
    SelectAStudentPageView: 'SelectAStudentPageView',
    SideProjectPageView: 'SideProject PageView',

    ReferralTabPageView: 'ReferralTabPageView',

    ClickRequestDemo: 'ClickRequestDemo',

    // click
    FacebookRegistrationClick: 'FacebookRegistrationClick',
    GoogleRegistrationClick: 'GoogleRegistrationClick',
    EmailSignUpButtonClick: 'EmailSignUpButtonClick',
    EmailLoginButtonClick: 'EmailLoginButtonClick',
    NotificationClick: 'NotificationClick',

    CompleteRegistration: 'CompleteRegistration',
    PlayMusicoTourVideo: 'PlayMusicoTourVideo',
    SignUp: 'SignUp',
    Add: 'Add',
    Sync: 'Sync',
    PlayOnFeed: 'PlayOnFeed',
    PlayOnLooperSection: 'PlayOnLooperSection',
    PlayOnStudio: 'PlayOnStudio',
    SendMessage: 'SendMessage',
    ChatOpen: 'ChatOpen',
    Share: 'Share',
    MusicMessageAdd: 'MusicMessageAdd',
    MusicMessageSend: 'MusicMessageSend',
    NewStemCreated: 'NewStemCreated',
    FeedCut: 'FeedCut',
    UploadOpen: 'UploadOpen',
    UploadDone: 'UploadDone',
    RecorderOpen: 'RecorderOpen',
    RecorderDone: 'RecorderDone'
});

export const statisticsState = Enum({
    Error: 'Error',
    Empty: 'Empty',
    Soon: 'Soon'
});

export const AttachmentType = Enum({
    Pdf: 'pdf',
    Doc: 'doc',
    Docx: 'docx',
    Msword: 'msword',
    Image: 'image',
    Xml: 'xml',
    ChordPro: 'chordpro',
    Unknown: 'unknown'
});

export const SignupType = Enum({
    ByTeacher: 'byTeacher',
    SelfService: 'selfService',
});

export const ExerciseActionType = Enum({
    Record: 'Record',
    Upload: 'Upload'
});

export const AdminLessonsState = Enum({
    All: 'All',
    Published: 'Published',
    Unpublished: 'Unpublished'
});

export const StudentLessonState = Enum({
    Pending: 'pending',
    Practiced: 'practiced',
    Active: 'active'
});

export const DeviceType = Enum({
    Mobile: 'mobile',
    Tablet: 'tablet',
    Desktop: 'desktop'
});

export const LatencyTestState = Enum({
    Preparation: 'preparation',
    Init: 'init',
    Running: 'running',
    Success: 'success',
    Error: 'error'
});

export const LatencyTestError = Enum({
    TooMuch: 'tooMuch',
    TooLittle: 'tooLittle',
    Unstable: 'unstable'
});

export const PromoType = Enum({
    None: -1,
    Teacher: 0,
    Founder: 1,
    Webinar: 2,
});

export const ProjectAssetsType = Enum({
    Text: 0,
    Notation: 1,
    Audio: 2,
    Video: 3,
    Image: 4
});

export const ActionType = Enum({
    Main: 'main',
    Other: 'other',
    Multiple: 'multiple'
});

export const StudioActionTypes = Enum({
    AudioRecord: 'audioRecord',
    AudioUpload: 'audioUpload',
    AudioLibrary: 'audioLibrary',
    AudioMusicoLibrary: 'audioMusicoLibrary',
    NotationUpload: 'notationUpload',
    VideoRecord: 'videoRecord',
    VideoLink: 'videoLink',
    VideoUpload: 'videoUpload',
    Overview: 'overview',
    Whiteboard: 'whiteboard',
    MoreAudio: 'moreAudio',
    MoreVideo: 'moreVideo',
    WhiteboardMultiple: 'whiteboardMultiple',
    ImageUpload: 'imageUpload',
    Other: 'other'
})

export const StudioMode = Enum({
    Welcome: 'welcome',
    Edit: 'edit',
    Preview: 'preview',
});

export const VideoTabState =  Enum({
    Initial: 'initial',
    Record: 'record',
    AttachLink: 'attachLink',
});

export const ImageTabState =  Enum({
    Initial: 'initial',
    Record: 'record'
});

export const ImageTypes =  Enum({
    Blank: 'blank',
    Staff: 'staff',
    Charts: 'charts',
    ChartsV2: 'New charts',
    Piano: 'piano',
    GuitarTab: 'guitarTab',
    FretBoard: 'fretBoard',
    FourStringsTABstaff: 'FourStringsTABstaff',
    FourStringsChordDiagramV2: 'New 4 Strings Chord Diagram',
    FourStringsChordDiagram: '4 Strings Chord Diagram',
    Drumline: 'drumline',
});

export const MediaRecorderState =  Enum({
    Stream: 'stream',
    Record: 'record',
    Preparing: 'preparing',
    Countdown: 'countdown',
    Error: 'error',
    Save: 'save'
});

export const DialogTypes =  Enum({
    AddGroup: 'AddGroup',
    AddStudent: 'AddStudent',
    AddEditSchool: 'AddEditSchool',
    AdminSaveActions: 'AdminSaveActions',
    CloneProjectSuccess: 'CloneProjectSuccess',
    CopyPasscode: 'CopyPasscode',
    DiscoverVideo: 'DiscoverVideo',
    DuplicateProjectSuccess: 'DuplicateProjectSuccess',
    EditNotations: 'EditNotations',
    GroupStudents: 'GroupStudents',
    LessonInfo: 'LessonInfo',
    MyLessons: 'MyLessons',
    SharedLessons: 'SharedLessons',
    ProfilePhotoEditor: 'ProfilePhotoEditor',
    SchoolAvatar: 'SchoolAvatar',
    SchoolUsers: 'SchoolUsers',
    StemAction: 'StemAction',
    StudioAbilities: 'StudioAbilities',
    StudioLibrary: 'StudioLibrary',
    Pricing: 'Pricing',
    AssignmentSummary: 'AssignmentSummary',
    ResendLogin: 'ResendLogin',
    Collection: 'Collection',
    RenameProject: 'RenameProject',
    PaymentConfirm: 'PaymentConfirm',
    StudentZoomMeeting: 'StudentZoomMeeting',
    StudentChats: 'StudentChats',
    AccessModal: 'AccessModal',
    StartPresentingModal: 'StartPresentingModal',
    PaymentAuthModal: 'PaymentAuthModal',
    TeacherStartMeeting: 'TeacherStartMeeting',
    AddSchoolUser: 'AddSchoolUser',
    MigrateTeachers: 'MigrateTeachers',
    ImportSchoolUsers: 'ImportSchoolUsers',
    ImportUsersResult: 'ImportUsersResult',
    StudentVideoDialog: 'StudentVideoDialog',
    CameraErrorDialog: 'CameraErrorDialog',
    LoginErrorDialog: 'LoginErrorDialog',
    StartVideoChat: 'StartVideoChat',
    DiscoverIntroLessonsDialog: 'DiscoverIntroLessonsDialog',
    SharePublicLinkDialog: 'SharePublicLinkDialog',
    StudentAddConfirmDialog: 'StudentAddConfirmDialog',
    ThemeSelectionDialog: 'ThemeSelectionDialog',
    AvatarSelectionDialog: 'AvatarSelectionDialog',
});

export const SharePublicLinkDialogTypes = Enum( {
    LibraryStudio: 'libraryStudio',
    TimelineStudio: 'timelineStudio',
    Library: 'library',
    Timeline: 'timeline',
    LibrarySingleStudent: 'librarySingleStudent',
    LibraryMultipleStudents: 'libraryMultipleStudents'
});

export const ReadMoreLinkTypes = Enum( {
    English : 'https://intercom.help/musico/en/articles/5526063-what-can-students-do-in-musico-without-logging-in'
})

export const ErrorType =  Enum({
    NotFound: 'NotFound',
    General: 'General'
});

export const SubscriptionPlans =  Enum({
    Free: 'free',
    Basic: 'basic',
    Academy: 'academy',
    Conservatory: 'conservatory',
    School: 'school',
    Custom: 'custom',
    Trial: 'trial',
    Unlimited: 'unlimited'
});

export const SchoolUserMode =  Enum({
    Teacher: 'teachers',
    Student: 'students',
    Admin: 'admins',
});

export const RemoteVideoState =  Enum({
    Init: 'init',
    Request: 'request',
    Approved: 'approved',
    ApprovedPending: 'approvedPending',
    Declined: 'declined',
    PeerEnd: 'peerEnd',
    Loading: 'loading',
    VideoStreamStarted: 'videoStreamStarted',
    SomethingWentWrong: 'somethingWentWrong'
});

export const ShareType =  Enum({
    Copy: 'copy',
    Facebook: 'facebook',
    Twitter: 'twitter',
    Whatsapp: 'whatsapp',
    Messenger: 'messenger',
    Email: 'email',
});

export const Special = Enum({
    None: 'none',
    Christmas: 'christmas',
    Valentine: 'valentine',
    Birthday: 'birthday',
});

export const shortcuts = Enum({
    StartVideoLesson: 'Start a Video Lesson',
    CreateNewLesson: 'Create New Lesson',
    AddStudent: 'Add a Student',
    CreateGroup: 'Create a Group',
    Referral: 'Referral',
});

export const NotificationSoundStatus = Enum({
    Enabled: 'on',
    MuteDuringVideo: 'offVideo',
    Mute: 'off',
});

export const RealtimeAction = Enum({
    Play: 'play',
    Pause: 'pause',
    MetronomeOn: 'metronomeOn',
    MetronomeOff: 'metronomeOff',
    SeekTo: 'seekTo',
    AudioRecord: 'audioRecord',
    VideoRecord: 'videoRecord',
    AudioUpload: 'audioUpload',
    VideoUpload: 'videoUpload'
});

export const LessonLibraryType = Enum( {
    MyLessons: 'my-lessons',
    SharedLessons: 'shared-lessons',
    DiscoverLessons: 'discover-lessons',
    CollectionLessons: 'collection-lessons'
})

export const DragAction = Enum( {
    Add: 'add',
    Share: 'share',
    Move: 'move',
    NotAllowed: 'notAllowed'
})

export const DropType = Enum({
    Folder: 'folder',
    Library: 'library',
    Module: 'module'
})

export const ModuleDragType = Enum( {
    Module: 'module',
    Lesson: 'lesson'
})

export const StudioViewType = Enum( {
    DefaultView : 'defaultView',
    MarketingView : 'marketingView',
    PublicView : 'publicView',
    ShareView : 'shareView',
    StudentView : 'studentView',
    BlockView : 'blockView',
})

export const DiscoverGalleriesFilterTypes = Enum( {
    RecentlyAdded: 'recentlyAdded',
    Beginner: 'beginner',
    TheoryAndExercises: 'techniqueExercises',
    Disney: 'disney',
    PopAndRock: 'famousSongs'
})

export const OnboardingStepTypes = Enum( {
    OnboardingHowDoYouTeachStep: 'howYouTeachStep',
    OnboardingInstrumentStep: 'instrumentStep',
    OnboardingHowManyStudents: 'howManyStudentsStep',
    OnboardingRole: 'roleStep',
})

export const HomePageCategoriesIndex = Enum({
    recently : 0,
    classical : 1,
    jazz : 2,
    pop : 3,
    exam : 4,
    theory : 5,
    children : 6,
    chamber : 7,
    movies : 8,
    disney : 9,
    musicals : 10,
    holiday : 11,
    country : 12,
    rap : 13,
    beginner : 1,
});

export const DiscoverFilterType = Enum( {
    text: 'text',
    category: 'category',
    level: 'level',
    skills: 'skills',
    keys: 'keys',
})

export const TimelineFilters = Enum( {
    All : 'all',
    Notes: 'notes',
})

export const Locales = Enum( {
    English: 'en-US',
    German: 'de-DE',
    Spanish: 'es-ES',
    Italian: 'it-IT',
    Hebrew: 'he-IL'
})

export const EmptyStateTypes = Enum( {
    StudentTimeline: 'StudentTimeline',
    TeacherTimeline: 'TeacherTimeline',
    PersonalLibrary: 'PersonalLibrary',
    NotesTimeline: 'NotesTimeline'
})

export const labels = Enum( {
    FromHeader: 'From Header',
    FromWizzard: 'From Wizzard',
    FromAddMenu: 'From Add Menu',
    FromAudio: 'From Audio',
    New: 'New',
    Success: 'Success',
    Error: 'Error'
})

export const PagePath = Enum( {
    SignUpDemo: '/signup/demo',
    SignUpSuccess: '/signup/success',
    SignUpStudent: '/signup/student',
    SignUpTeacher: '/signup/teacher',
    SignUpSelect: '/signup/select',
    ShareContainer: '/share/:shareId',
    TermsOfUseContainer: '/terms',
    PaymentContainerStudents: '/payment/:students',
    PaymentContainer: '/payment',
    PrivacyPolicy: '/policy',
    ResetPasswordContainer: '/auth/forgot-password',
    SignUpConfirmContainer: '/auth/sign-up/confirm',
    RegistrationContainer: '/auth2',
    CreateContainerWithId: '/depr/create/:projectId',
    CreateContainer: '/depr/create',
    StudioContainerWithId: '/create/:projectId',
    SigninPage: '/signin',
    StudioContainer: '/create',
    SetInitialPasswordPage: '/first-password',
    SocialLogin: '/social',
    MeetingsContainer: '/book-a-meeting',
    DiscoverLessonsWrapper: '/discover',
    MainContainer: '/',
    OnBoardingContainer: '/home/onboarding/:step?',
    StudentTimeline: '/home/select/student/:id',
    GroupTimeline: '/home/select/group/:id',
    SelectStudentContainer: '/home/select',
    LessonPlanLibrary: '/home/lesson-plans/:type?/:folderId?',
    LessonPage: '/home/lesson/:id',
    GroupPage: '/home/group/:id',
    ManagePage: '/student-list',
    SchoolTeachersPage: '/school/teachers',
    SchoolStudentsPage: '/school/students',
    SchoolsContainer: '/home/schools',
    SchoolContainer: '/home/school/:id',
    AdminStudentsContainer: '/home/admin/students-list',
    AdminPayproContainer: '/home/admin/paypro',
    AdminLessonsContainer: '/home/admin/lessons',
    AdminHomeContainer: '/home/admin',
    JamsLibrary: '/home/jam',
    ChangePasswordContainer: '/change-password',
    SupportPage: '/support',
    ProfilePage: '/profile/:activeTab?',
    PricingPage: '/pricing'
})

export const StudentsView = Enum({
    Tiles : 'tiles',
    List: 'list'
})

export const MarkUpMenuTypes = Enum({
    Pen : 'pen',
    Highlighter: 'highlighter',
    NotationText: 'notation-text',
    Text: 'text',
    Shapes: 'shapes',
    Stickers: 'stickers',
    Symbols: 'music-symbol'
})

export const MarkupIconKind = Enum({
    Canvas: 'canvas',
    Panel: 'panel'
})

export const BackgroundCardFolders = Enum({
    Themes: 'themes',
    Categories: 'categories',
    Avatars: 'avatars'
})